// import { useEffect, useState } from "react";
// import { SocketURL } from "../ApiService/Axios/Index";
// import { getLocalStorageItem } from "../Utils/Index";
// import { io } from "socket.io-client";
// import { triggerSnackbar } from "../Services/NotificationService";

// const UseSocket = (path, setState = () => {}, apiCall = () => {}) => {
//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     const socketInstance = io(`${SocketURL}/${path}`, {
//       auth: {
//         token: getLocalStorageItem("access_token"),
//       },
//       transports: ["websocket"],
//       withCredentials: true,
//     });

//     setSocket(socketInstance);

//     return () => {
//       socketInstance.disconnect();
//     };
//     //eslint-disable-next-line
//   }, []);

//   useEffect(() => {
//     if (socket) {
//       socket.on("notification_dashboard", (data) => {
//         const audio = new Audio("/notification.mpeg");
//         audio?.play().catch((err) => console.log(err, "Playback error"));
//         triggerSnackbar("New order arrived", "success");
//         setState(data?.data);
//       });

//       socket.on("order_receive", (data) => {
//         const audio = new Audio("/notification.mpeg");
//         audio?.play().catch((err) => console.log(err, "Playback error"));
//         apiCall();
//         triggerSnackbar("New message arrived", "success");
//       });

//       socket.on("notification_AssignPerson", (data) => {
//         const audio = new Audio("/notification.mpeg");
//         audio?.play().catch((err) => console.log(err, "Playback error"));
//         apiCall();
//         triggerSnackbar("New message arrived", "success");
//       });

//       socket.on("receive_order_restaurant", (data) => {
//         const audio = new Audio("/notification.mpeg");
//         audio?.play().catch((err) => console.log(err, "Playback error"));
//         apiCall();
//         triggerSnackbar("New message arrived", "success");
//       });
//     }

//     return () => {
//       if (socket) {
//         socket.off("notification_dashboard");
//         socket.off("order_receive");
//         socket.off("notification_AssignPerson");
//         socket.off("receive_order_restaurant");
//       }
//     };
//     //eslint-disable-next-line
//   }, [socket]);

//   return { socket };
// };

// export default UseSocket;




// import { useEffect, useState } from "react";
// import { io } from "socket.io-client";
// import { SocketURL } from "../ApiService/Axios/Index";
// import { getLocalStorageItem } from "../Utils/Index";
// import { triggerSnackbar } from "../Services/NotificationService";

// const UseSocket = (path, setState = () => { }, apiCall = () => { }) => {
//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     const token = getLocalStorageItem("access_token");

//     const url = `${SocketURL.replace(/\/$/, "")}/${path}`;

//     console.log("====================================");
//     console.log("[SOCKET] Initializing");
//     console.log("[SOCKET] URL:", url);
//     console.log("[SOCKET] Namespace:", path);
//     console.log(
//       "[SOCKET] Token:",
//       token ? token.substring(0, 25) + "..." : "NO TOKEN"
//     );
//     console.log("====================================");

//     // const socketInstance = io(url, {
//     //   auth: {
//     //     token,
//     //   },
//     //   transports: ["websocket"],
//     //   withCredentials: true,
//     //   reconnection: true,
//     //   reconnectionAttempts: 5,
//     //   reconnectionDelay: 1000,
//     // });
//     const socketInstance = io(url, { auth: { token, }, transports: ["polling", "websocket"], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 1000, });

//     socketInstance.on("connect", () => {
//       console.log("====================================");
//       console.log("[SOCKET] CONNECTED");
//       console.log("Socket ID:", socketInstance.id);
//       console.log("Namespace:", path);
//       console.log("====================================");
//     });

//     socketInstance.on("connected", (data) => {
//       console.log("[SOCKET] Connected Event:", data);
//     });

//     socketInstance.on("disconnect", (reason) => {
//       console.log("[SOCKET] Disconnected:", reason);
//     });

//     socketInstance.on("connect_error", (err) => {
//       console.log("====================================");
//       console.log("[SOCKET] CONNECT ERROR");
//       console.log("Message:", err.message);
//       console.log("Description:", err.description);
//       console.log("Context:", err.context);
//       console.log(err);
//       console.log("====================================");
//     });

//     socketInstance.on("error", (err) => {
//       console.log("[SOCKET] Server Error:", err);
//     });

//     // Log every incoming event
//     socketInstance.onAny((event, ...args) => {
//       console.log("====================================");
//       console.log("[SOCKET EVENT]");
//       console.log("Event:", event);
//       console.log("Payload:", args);
//       console.log("====================================");
//     });

//     setSocket(socketInstance);

//     return () => {
//       console.log("[SOCKET] Disconnecting...");
//       socketInstance.disconnect();
//     };
//   }, [path]);

//   useEffect(() => {
//     if (!socket) return;
//     console.log("SocketURL:", SocketURL);
//     console.log("Namespace:", path);

//     const url = `${SocketURL.replace(/\/$/, "")}/${path}`;

//     console.log("Final URL:", url);
//     socket.on("new_order", (data) => {
//       console.log("new_order", data);

//       new Audio("/notification.mpeg")
//         .play()
//         .catch((err) => console.log(err));

//       triggerSnackbar("New order arrived", "success");

//       setState(data);
//     });

//     socket.on("order_receive", (data) => {
//       console.log("order_receive", data);

//       new Audio("/notification.mpeg")
//         .play()
//         .catch((err) => console.log(err));

//       apiCall();

//       triggerSnackbar("New message arrived", "success");
//     });
//     // socket.on("dashboard_update", (data) => {
//     //   console.log("dashboard_update", data);

//     //   apiCall();
//     // });

//     socket.on("notification_AssignPerson", (data) => {
//       console.log("notification_AssignPerson", data);

//       new Audio("/notification.mpeg")
//         .play()
//         .catch((err) => console.log(err));

//       apiCall();

//       triggerSnackbar("New message arrived", "success");
//     });

//     socket.on("receive_order_restaurant", (data) => {
//       console.log("receive_order_restaurant", data);

//       new Audio("/notification.mpeg")
//         .play()
//         .catch((err) => console.log(err));

//       apiCall();

//       triggerSnackbar("New message arrived", "success");
//     });

//     // Backend emits this
//     socket.on("order_status_update", (data) => {
//       console.log("order_status_update", data);
//     });

//     // Backend emits this
//     socket.on("group_order_status_update", (data) => {
//       console.log("group_order_status_update", data);
//     });

//     // Backend emits this
//     socket.on("group_order_finalized", (data) => {
//       console.log("group_order_finalized", data);
//     });


//     socket.on("dashboard_update", (data) => {
//       console.log("dashboard_update", data);
//       setState(data);

//       apiCall();
//     });



//     return () => {
//       socket.off();
//     };
//   }, [socket]);

//   return { socket };
// };

// export default UseSocket;

import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { SocketURL } from "../ApiService/Axios/Index";
import { getLocalStorageItem } from "../Utils/Index";
import { triggerSnackbar } from "../Services/NotificationService";

const UseSocket = (path, setState = () => { }, apiCall = () => { }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = getLocalStorageItem("access_token");

    const url = `${SocketURL.replace(/\/$/, "")}/${path}`;

    console.log("====================================");
    console.log("[SOCKET] Initializing");
    console.log("[SOCKET] URL:", url);
    console.log("[SOCKET] Namespace:", path);
    console.log(
      "[SOCKET] Token:",
      token ? token.substring(0, 25) + "..." : "NO TOKEN"
    );
    console.log("====================================");

    const socketInstance = io(url, {
      auth: {
        token: token,
      },
      transports: ["websocket", "polling"],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
    });

    socketInstance.on("connect", () => {
      console.log("====================================");
      console.log("[SOCKET] CONNECTED");
      console.log("Socket ID:", socketInstance.id);
      console.log("Namespace:", path);
      console.log("====================================");
    });

    socketInstance.on("connected", (data) => {
      console.log("[SOCKET] Connected Event:", data);
      // Check if connection was successful
      if (data.message) {
        console.log("[SOCKET] Connection message:", data.message);
      }
      // If user is authenticated, store user info
      if (data.customerId || data.restaurantId) {
        console.log("[SOCKET] Authenticated as:", {
          customerId: data.customerId,
          restaurantId: data.restaurantId,
          role: data.role
        });
      }
    });

    socketInstance.on("disconnect", (reason) => {
      console.log("[SOCKET] Disconnected:", reason);
      if (reason === "io server disconnect") {
        // Server initiated disconnect, reconnect manually
        socketInstance.connect();
      }
    });

    socketInstance.on("connect_error", (err) => {
      console.log("====================================");
      console.log("[SOCKET] CONNECT ERROR");
      console.log("Message:", err.message);
      console.log("Description:", err.description);
      console.log("Context:", err.context);
      console.log(err);
      console.log("====================================");
      // If authentication fails, try to reconnect with new token
      if (err.message === "Authentication Invalid") {
        const newToken = getLocalStorageItem("access_token");
        if (newToken && newToken !== token) {
          socketInstance.auth.token = newToken;
          socketInstance.connect();
        }
      }
    });

    socketInstance.on("error", (err) => {
      console.log("[SOCKET] Server Error:", err);
    });

    // Log every incoming event (for debugging)
    socketInstance.onAny((event, ...args) => {
      console.log("====================================");
      console.log("[SOCKET EVENT]");
      console.log("Event:", event);
      console.log("Payload:", args);
      console.log("====================================");
    });

    setSocket(socketInstance);

    return () => {
      console.log("[SOCKET] Disconnecting...");
      if (socketInstance) {
        socketInstance.disconnect();
      }
    };
  }, [path]);

  // Event listeners setup
  useEffect(() => {
    if (!socket) return;

    console.log("[SOCKET] Setting up event listeners for namespace:", path);

    // ⚠️ CRITICAL FIX: Listen to "order_update" event
    // This is the event the backend actually emits when a new order arrives
    socket.on("order_update", (data) => {
      console.log("[SOCKET] order_update event received:", data);
      try {
        new Audio("/notification.mpeg")
          .play()
          .catch((err) => console.log("Audio play error:", err));
      } catch (error) {
        console.log("Notification audio error:", error);
      }

      // Trigger the state callback so consumers (like ProjectLayout) get notified
      if (typeof setState === "function") {
        setState(data);
      }
      if (typeof apiCall === "function") {
        apiCall(data);
      }
    });
    // New order notification (for restaurant, kitchen, service, dashboard)
    socket.on("new_order", (data) => {
      console.log("[SOCKET] new_order event received:", data);
      try {
        new Audio("/notification.mpeg")
          .play()
          .catch((err) => console.log("Audio play error:", err));
      } catch (error) {
        console.log("Notification audio error:", error);
      }

      triggerSnackbar("New order arrived!", "success");
      if (typeof setState === "function") {
        setState(data);
      }
    });

    // Order receive (for service staff)
    socket.on("order_receive", (data) => {
      console.log("[SOCKET] order_receive event received:", data);
      try {
        new Audio("/notification.mpeg")
          .play()
          .catch((err) => console.log("Audio play error:", err));
      } catch (error) {
        console.log("Notification audio error:", error);
      }

      triggerSnackbar(data.message || "New order received!", "info");
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Dashboard update (for restaurant and dashboard)
    socket.on("dashboard_update", (data) => {
      console.log("[SOCKET] dashboard_update event received:", data);
      if (typeof setState === "function") {
        setState(data);
      }
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Order status update (for customers and restaurant)
    socket.on("order_status_update", (data) => {
      console.log("[SOCKET] order_status_update event received:", data);
      const statusMessages = {
        'waiting_for_confirmation': 'Order waiting for confirmation',
        'confirmed': 'Order confirmed',
        'preparing': 'Order is being prepared',
        'ready': 'Order is ready',
        'served': 'Order has been served',
        'completed': 'Order completed',
        'cancelled': 'Order cancelled'
      };
      const message = statusMessages[data.status] || `Order status: ${data.status}`;
      triggerSnackbar(message, "info");
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Group order status update
    socket.on("group_order_status_update", (data) => {
      console.log("[SOCKET] group_order_status_update event received:", data);
      triggerSnackbar(`Group order ${data.status}`, "info");
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Group order finalized
    socket.on("group_order_finalized", (data) => {
      console.log("[SOCKET] group_order_finalized event received:", data);
      triggerSnackbar(`Group order finalized! Order #${data.orderId}`, "success");
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Group order placed
    socket.on("group_order_placed", (data) => {
      console.log("[SOCKET] group_order_placed event received:", data);
      triggerSnackbar(`Group order placed! Order #${data.orderNumber}`, "success");
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Group order action (add/remove items)
    socket.on("group_order_action", (data) => {
      console.log("[SOCKET] group_order_action event received:", data);
      const actionMessages = {
        'add': 'Item added to group order',
        'remove': 'Item removed from group order',
        'update': 'Item updated in group order'
      };
      triggerSnackbar(actionMessages[data.action] || 'Group order updated', "info");
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Refresh group order
    socket.on("refresh_group_order", (data) => {
      console.log("[SOCKET] refresh_group_order event received:", data);
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Group session state
    socket.on("group_session_state", (data) => {
      console.log("[SOCKET] group_session_state event received:", data);
      if (typeof setState === "function") {
        setState(data);
      }
    });

    // Joined group session
    socket.on("joined_group_session", (data) => {
      console.log("[SOCKET] joined_group_session event received:", data);
      triggerSnackbar(data.message || "Joined group session", "success");
    });

    // Joined order room
    socket.on("joined_order_room", (data) => {
      console.log("[SOCKET] joined_order_room event received:", data);
      triggerSnackbar(data.message || "Joined order room", "success");
    });

    // Table status update
    socket.on("table_status_update", (data) => {
      console.log("[SOCKET] table_status_update event received:", data);
      if (typeof apiCall === "function") {
        apiCall();
      }
    });

    // Dashboard refreshed
    socket.on("dashboard_refreshed", (data) => {
      console.log("[SOCKET] dashboard_refreshed event received:", data);
      triggerSnackbar("Dashboard refreshed", "success");
    });

    // Connection event
    socket.on("connected", (data) => {
      console.log("[SOCKET] connected event received:", data);
    });

    // Clean up event listeners
    return () => {
      console.log("[SOCKET] Cleaning up event listeners for namespace:", path);
      socket.off("new_order");
      socket.off("order_receive");
      socket.off("dashboard_update");
      socket.off("order_status_update");
      socket.off("group_order_status_update");
      socket.off("group_order_finalized");
      socket.off("group_order_placed");
      socket.off("group_order_action");
      socket.off("refresh_group_order");
      socket.off("group_session_state");
      socket.off("joined_group_session");
      socket.off("joined_order_room");
      socket.off("table_status_update");
      socket.off("dashboard_refreshed");
      socket.off("connected");
      socket.off("order_update");
    };
  }, [socket, path, setState, apiCall]);

  // Function to join a group session
  const joinGroupSession = (sessionId) => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Joining group session:", sessionId);
    socket.emit("join_group_session", { sessionId });
  };

  // Function to leave a group session
  const leaveGroupSession = (sessionId) => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Leaving group session:", sessionId);
    socket.emit("leave_group_session", { sessionId });
  };

  // Function to join an order room
  const joinOrderRoom = (orderId, orderType = 'single') => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Joining order room:", orderId);
    socket.emit("join_order_room", { orderId, orderType });
  };

  // Function to leave an order room
  const leaveOrderRoom = (orderId) => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Leaving order room:", orderId);
    socket.emit("leave_order_room", { orderId });
  };

  // Function to emit group order action
  const emitGroupOrderAction = (sessionId, action, customerId, items) => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Emitting group order action:", { sessionId, action, customerId, items });
    socket.emit("group_order_action", { sessionId, action, customerId, items });
  };

  // Function to request dashboard update
  const requestDashboardUpdate = () => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Requesting dashboard update");
    socket.emit("request_dashboard_update");
  };

  // Function to request recent orders
  const requestRecentOrders = (limit = 10) => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Requesting recent orders");
    socket.emit("request_recent_orders", { limit });
  };

  // Function to request payment methods
  const requestPaymentMethods = () => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Requesting payment methods");
    socket.emit("request_payment_methods");
  };

  // Function to refresh dashboard
  const refreshDashboard = () => {
    if (!socket) {
      console.error("[SOCKET] Socket not connected");
      return;
    }
    console.log("[SOCKET] Refreshing dashboard");
    socket.emit("refresh_dashboard");
  };

  return {
    socket,
    joinGroupSession,
    leaveGroupSession,
    joinOrderRoom,
    leaveOrderRoom,
    emitGroupOrderAction,
    requestDashboardUpdate,
    requestRecentOrders,
    requestPaymentMethods,
    refreshDashboard
  };
};

export default UseSocket;